import React, { useEffect, useState } from 'react'; 
import api from '../utils/axiosInstance';
import { useImmerReducer } from 'use-immer';
import { Button, Typography, Box, Grid, Avatar, CircularProgress, 
        IconButton, Card, CardMedia, CardActions, CardContent, Container, TextField } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useNavigate, useParams } from 'react-router-dom';
import defaultProfilePicture from "./Assets/default3.jpg";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import axios from 'axios';

function AgencyDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;

  const initialState = {
    userProfile: {
      agencyNameValue: "",
      phoneNumberValue: "",
      bioValue: "",
      sellerListings: [],
      profilePictureValue: "",
    },
    dataIsLoading: true,
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchUserProfileInfo":
        draft.userProfile.agencyNameValue = action.profileObject.agency_name || "";
        draft.userProfile.phoneNumberValue = action.profileObject.phone_number || "";
        draft.userProfile.bioValue = action.profileObject.bio || "";
        draft.userProfile.profilePictureValue = action.profileObject.profile_picture || "";
        break;
      case "updateListings":
        draft.userProfile.sellerListings = action.listings;
        break;
      case "loadingDone":
        draft.dataIsLoading = false;
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    next: null,
    previous: null,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    async function GetProfileInfo() {
      try {
        const response = await api.get(
          // `http://localhost:8000/api/profile/${params.id}/`
          `${apiUrl}/api/profile/${params.id}/`
        );
        dispatch({ type: "catchUserProfileInfo", profileObject: response.data });
        dispatch({ type: "loadingDone" });
      } catch (e) {
        console.log(e.response);
      }
    }
    GetProfileInfo();
  }, [params.id, dispatch]);
  
  useEffect(() => {
    async function GetPaginatedListings() {
      try {
        const response = await api.get(
          // `http://localhost:8000/api/profile/${params.id}/listings/?page=${currentPage}&title=${searchTerm}`
          `${apiUrl}/api/profile/${params.id}/listings/?page=${currentPage}&title=${searchTerm}`
        );
        
        dispatch({
          type: "updateListings",
          listings: response.data.results
        });
  
        setPagination({
          next: response.data.next,
          previous: response.data.previous,
        });
        
        dispatch({ type: 'loadingDone' });
      } catch (e) {
        console.log(e.response);
      }
    }
    GetPaginatedListings();
  }, [currentPage, searchTerm, params.id, dispatch]);  

  const handleNextPage = () => {
    if (pagination.next) {
      setCurrentPage((prevPage) => prevPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePreviousPage = () => {
    if (pagination.previous) {
      setCurrentPage((prevPage) => prevPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  if (state.dataIsLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
        <HomeIcon fontSize="large" />
        <Typography variant="h4" ml={1}>
          Agency Detail
        </Typography>
      </Box>

      {/* Profile Section */}
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Grid container spacing={2} alignItems="center" direction="column">
          <Grid item>
            <Avatar
              // src={state.userProfile.profilePictureValue || defaultProfilePicture}
              // src={`https://res.cloudinary.com/dvisrqloj/${state.userProfile.profilePictureValue}` || defaultProfilePicture}
              src={state.userProfile.profilePictureValue ? `https://res.cloudinary.com/dvisrqloj/${state.userProfile.profilePictureValue}` : defaultProfilePicture}
              alt="Profile Picture"
              sx={{ width: 150, height: 150 }}
            />
          </Grid>

          <Grid item>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              {state.userProfile.agencyNameValue || ''}
            </Typography>
            {state.userProfile.phoneNumberValue && (
              <Typography variant="h6">
                <IconButton>
                  <LocalPhoneIcon sx={{ mr: 1 }} />
                  {state.userProfile.phoneNumberValue}
                </IconButton>
              </Typography>
            )}
          </Grid>

          <Grid item sx={{ mt: 1, px: 2 }}>
            <Typography variant="body1">
              {state.userProfile.bioValue}
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Search Input */}
      <Box display="flex" justifyContent="center" mt={3} mb={2}>
        <TextField
          label="Search Listings"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          style={{ width: '80%', maxWidth: '600px' }}
        />
      </Box>

      {/* Listings Section */}
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={2} justifyContent="center">
          {state.userProfile.sellerListings.length === 0 ? (
            <Typography variant="h6" color="textSecondary" align="center">
              No listings found
            </Typography>
          ) : (
            state.userProfile.sellerListings.map((listing) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={listing.id}>
                <Card>
                  <CardMedia
                    sx={{ height: { xs: 200, sm: 250, md: 140 } }}
                    image={`https://res.cloudinary.com/dvisrqloj/${listing.picture1}` || defaultProfilePicture}
                    alt="Listing Picture"
                    onClick={() => navigate(`/listing/${listing.id}`)}
                    onError={(e) => (e.target.src = defaultProfilePicture)}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h6">
                      {listing.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                      {listing.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {listing.property_status === "Sale"
                      ? `${listing.listing_type}: ₦${listing.price.toLocaleString()}`
                      : `${listing.listing_type}: ₦${listing.price.toLocaleString()}/${listing.rental_frequency}`}
                  </CardActions>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
        
        {/* Pagination Controls */}
        <Box display="flex" justifyContent="center" mt={2} mb={4}>
          <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
            Previous
          </Button>
          <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} sx={{ ml: 2 }}>
            Next
          </Button>
        </Box>
      </Container>
    </div>
  );
}

export default AgencyDetail;

// worked bestttt
// import React, { useEffect, useState } from 'react';
// import api from '../utils/axiosInstance';
// import { useImmerReducer } from 'use-immer';
// import { Button, Typography, Box, Grid, Avatar, CircularProgress, 
//         IconButton, Card, CardMedia, CardActions, CardContent, Container } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import { useNavigate, useParams } from 'react-router-dom';
// import defaultProfilePicture from "./Assets/default3.jpg";
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

// function AgencyDetail() {
//   const navigate = useNavigate();
//   const params = useParams();

//   const initialState = {
//     userProfile: {
//       agencyNameValue: "",
//       phoneNumberValue: "",
//       bioValue: "",
//       sellerListings: [],
//       profilePictureValue: "",
//     },
//     dataIsLoading: true,
//   };

//   function ReducerFunction(draft, action) {
//     switch (action.type) {
//       case "catchUserProfileInfo":
//         draft.userProfile.agencyNameValue = action.profileObject.agency_name || "";
//         draft.userProfile.phoneNumberValue = action.profileObject.phone_number || "";
//         draft.userProfile.bioValue = action.profileObject.bio || "";
//         draft.userProfile.profilePictureValue = action.profileObject.profile_picture || "";
//         break;
//       case "updateListings":
//         draft.userProfile.sellerListings = action.listings;
//         break;
//       case "loadingDone":
//         draft.dataIsLoading = false;
//         break;
//       default:
//         break;
//     }
//   }

//   const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState({
//     next: null,
//     previous: null,
//   });

//   useEffect(() => {
//     async function GetProfileInfo() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profile/${params.id}/`);
//         dispatch({ type: "catchUserProfileInfo", profileObject: response.data });
//         dispatch({ type: "loadingDone" });
//       } catch (e) {
//         console.log(e.response);
//       }
//     }
//     GetProfileInfo();
//   }, [params.id, dispatch]);
  
//   useEffect(() => {
//     async function GetPaginatedListings() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profile/${params.id}/listings/?page=${currentPage}`);
        
//         dispatch({
//           type: "updateListings",
//           listings: response.data.results
//         });
  
//         setPagination({
//           next: response.data.next,
//           previous: response.data.previous,
//         });
        
//         dispatch({ type: 'loadingDone' });
//       } catch (e) {
//         console.log(e.response);
//       }
//     }
//     GetPaginatedListings();
//   }, [currentPage, params.id, dispatch]);  

//   const handleNextPage = () => {
//     if (pagination.next) {
//       setCurrentPage((prevPage) => prevPage + 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handlePreviousPage = () => {
//     if (pagination.previous) {
//       setCurrentPage((prevPage) => prevPage - 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   if (state.dataIsLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Agency Detail
//         </Typography>
//       </Box>

//       {/* Profile Section */}
//       <Container maxWidth="md" sx={{ textAlign: 'center' }}>
//         <Grid container spacing={2} alignItems="center" direction="column">
//           <Grid item>
//             <Avatar
//               src={state.userProfile.profilePictureValue || defaultProfilePicture}
//               alt="Profile Picture"
//               sx={{ width: 150, height: 150 }}
//             />
//           </Grid>

//           <Grid item>
//             <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
//               {state.userProfile.agencyNameValue || ''}
//             </Typography>
//             {state.userProfile.phoneNumberValue && (
//               <Typography variant="h6">
//                 <IconButton>
//                   <LocalPhoneIcon sx={{ mr: 1 }} />
//                   {state.userProfile.phoneNumberValue}
//                 </IconButton>
//               </Typography>
//             )}
//           </Grid>

//           <Grid item sx={{ mt: 1, px: 2 }}>
//             <Typography variant="body1">
//               {state.userProfile.bioValue}
//             </Typography>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Listings Section */}
//       <Container maxWidth="lg" sx={{ mt: 4 }}>
//         <Grid container spacing={2} justifyContent="center">
//           {state.userProfile.sellerListings.map((listing) => (
//             <Grid item xs={12} sm={6} md={4} lg={3} key={listing.id}>
//               <Card>
//                 <CardMedia
//                   sx={{ height: { xs: 200, sm: 250, md: 140 } }}
//                   image={listing.picture1 || defaultProfilePicture}
//                   alt="Listing Picture"
//                   onClick={() => navigate(`/listing/${listing.id}`)}
//                   onError={(e) => (e.target.src = defaultProfilePicture)}
//                 />
//                 <CardContent>
//                   <Typography gutterBottom variant="h6">
//                     {listing.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" noWrap>
//                     {listing.description}
//                   </Typography>
//                 </CardContent>
//                 <CardActions>
//                   {listing.property_status === "Sale"
//                     ? `${listing.listing_type}: ₦${listing.price.toLocaleString()}`
//                     : `${listing.listing_type}: ₦${listing.price.toLocaleString()}/${listing.rental_frequency}`}
//                 </CardActions>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
        
//         {/* Pagination Controls */}
//         <Box display="flex" justifyContent="center" mt={2} mb={4}>
//           <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
//             Previous
//           </Button>
//           <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} sx={{ ml: 2 }}>
//             Next
//           </Button>
//         </Box>
//       </Container>
//     </div>
//   );
// }

// export default AgencyDetail;

// import React, { useEffect, useState } from 'react';
// import api from '../utils/axiosInstance';
// import { useImmerReducer } from 'use-immer';
// import { Button, Typography, Box, Grid, Avatar, CircularProgress, 
//         IconButton, Card, CardMedia, CardActions, CardContent, Container } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';
// import { useNavigate, useParams } from 'react-router-dom';
// import defaultProfilePicture from "./Assets/default3.jpg";
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

// function AgencyDetail() {
//   const navigate = useNavigate();
//   const params = useParams();

//   const initialState = {
//     userProfile: {
//       agencyNameValue: "",
//       phoneNumberValue: "",
//       bioValue: "",
//       sellerListings: [],
//       profilePictureValue: "",
//     },
//     dataIsLoading: true,
//   };

//   function ReducerFunction(draft, action) {
//     switch (action.type) {
//       case "catchUserProfileInfo":
//         draft.userProfile.agencyNameValue = action.profileObject.agency_name || "";
//         draft.userProfile.phoneNumberValue = action.profileObject.phone_number || "";
//         draft.userProfile.bioValue = action.profileObject.bio || "";
//         draft.userProfile.profilePictureValue = action.profileObject.profile_picture || "";
//         break;
//       case "updateListings":
//         draft.userProfile.sellerListings = action.listings;
//         break;
//       case "loadingDone":
//         draft.dataIsLoading = false;
//         break;
//       default:
//         break;
//     }
//   }

//   const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState({
//     next: null,
//     previous: null,
//   });

//   useEffect(() => {
//     async function GetProfileInfo() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profile/${params.id}/`);
//         dispatch({ type: "catchUserProfileInfo", profileObject: response.data });
//         dispatch({ type: "loadingDone" });
//       } catch (e) {
//         console.log(e.response);
//       }
//     }
//     GetProfileInfo();
//   }, [params.id, dispatch]);
  
//   useEffect(() => {
//     async function GetPaginatedListings() {
//       try {
//         const response = await api.get(`http://localhost:8000/api/profile/${params.id}/listings/?page=${currentPage}`);
        
//         dispatch({
//           type: "updateListings",
//           listings: response.data.results
//         });
  
//         setPagination({
//           next: response.data.next,
//           previous: response.data.previous,
//         });
        
//         dispatch({ type: 'loadingDone' });
//       } catch (e) {
//         console.log(e.response);
//       }
//     }
//     GetPaginatedListings();
//   }, [currentPage, params.id, dispatch]);  

//   const handleNextPage = () => {
//     if (pagination.next) {
//       setCurrentPage((prevPage) => prevPage + 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   const handlePreviousPage = () => {
//     if (pagination.previous) {
//       setCurrentPage((prevPage) => prevPage - 1);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   if (state.dataIsLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Agency Detail
//         </Typography>
//       </Box>

//       {/* Profile Section */}
//       <Container maxWidth="md">
//         <Grid container spacing={2} alignItems="center" direction="column">
//           <Grid item>
//             {state.userProfile.profilePictureValue ? (
//               <Avatar
//                 src={typeof state.userProfile.profilePictureValue === 'string'
//                   ? state.userProfile.profilePictureValue
//                   : URL.createObjectURL(state.userProfile.profilePictureValue)}
//                 alt="Profile Picture"
//                 sx={{ width: 150, height: 150 }}
//               />
//             ) : (
//               <Avatar
//                 src={defaultProfilePicture}
//                 alt="Profile Picture"
//                 sx={{ width: 150, height: 150 }}
//               />
//             )}
//           </Grid>

//           <Grid item>
//             <Typography variant="h5" style={{ textAlign: 'center' }}>
//               <span style={{ fontWeight: 'bold' }}>{state.userProfile.agencyNameValue || ''}</span>
//             </Typography>
//             {state.userProfile.phoneNumberValue && (
//               <Typography variant="h6" style={{ textAlign: 'center' }}>
//                 <IconButton>
//                   <LocalPhoneIcon sx={{ mr: 1 }} />
//                   {state.userProfile.phoneNumberValue}
//                 </IconButton>
//               </Typography>
//             )}
//           </Grid>

//           <Grid item style={{ marginTop: "1rem", padding: "5px" }}>
//             <Typography variant="body1" align="center">
//               {state.userProfile.bioValue}
//             </Typography>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Listings Section */}
//       <Container maxWidth="lg">
//         <Grid container spacing={2} justifyContent="center" style={{ padding: "10px" }}>
//           {state.userProfile.sellerListings.map((listing) => (
//             <Grid item xs={12} sm={6} md={4} lg={3} key={listing.id}>
//               <Card>
//                 <CardMedia
//                   sx={{ height: 140 }}
//                   image={listing.picture1 || defaultProfilePicture}
//                   alt="Listing Picture"
//                   onClick={() => navigate(`/listing/${listing.id}`)}
//                   onError={(e) => e.target.src = defaultProfilePicture} // Fallback if image fails to load
//                 />
//                 <CardContent>
//                   <Typography gutterBottom variant="h5" component="div">
//                     {listing.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {listing.description.substring(0, 100)}
//                   </Typography>
//                 </CardContent>
//                 <CardActions>
//                   {listing.property_status === "Sale"
//                     ? `${listing.listing_type}: ₦${listing.price.toLocaleString()}`
//                     : `${listing.listing_type}: ₦${listing.price.toLocaleString()}/${listing.rental_frequency}`}
//                 </CardActions>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//         {/* Pagination Controls */}
//         <Box display="flex" justifyContent="center" padding="1rem">
//           <Button variant="contained" disabled={!pagination.previous} onClick={handlePreviousPage}>
//             Previous
//           </Button>
//           <Button variant="contained" disabled={!pagination.next} onClick={handleNextPage} style={{ marginLeft: '10px' }}>
//             Next
//           </Button>
//         </Box>
//       </Container>
//     </div>
//   );
// }

// export default AgencyDetail;